export interface VideoUploadResponse {
  message_id: number
  transcription?: string
  duration_seconds?: number
  video_url?: string  // BUG-048: permanent URL for uploaded video
  // Ekman emotion analysis
  emotion_detected?: string
  emotion_confidence?: number
  emotion_intensity?: number
  emotion_valence?: number
  emotion_arousal?: number
  facial_cues?: string[]
  secondary_emotion?: string
  therapeutic_context?: string
  // Therapist response
  therapist_response?: string
  therapist_name?: string
}

export interface ImageUploadResponse {
  message_id: number
  emotion_detected?: string
  emotion_confidence?: number
  analysis_summary?: string
  therapist_response?: string
  therapist_name?: string
}

export async function uploadVideo(
  file: Blob,
  options?: {
    sessionId?: number
    triggerResponse?: boolean
  }
): Promise<VideoUploadResponse> {
  const formData = new FormData()
  formData.append('file', file, 'video.webm')

  if (options?.sessionId) {
    formData.append('session_id', String(options.sessionId))
  }
  if (options?.triggerResponse !== undefined) {
    formData.append('trigger_response', String(options.triggerResponse))
  }

  // Use fetch instead of axios to avoid Content-Type issues with FormData
  // Dynamic import to avoid circular dependency issues
  const { useAuthStore } = await import('../stores/authStore')
  const token = useAuthStore.getState().accessToken

  const response = await fetch('/api/v1/media/video/upload', {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      // Don't set Content-Type - browser will set it with boundary for FormData
    },
    body: formData,
  })

  if (!response.ok) {
    const error = await response.text()
    throw new Error(`Upload failed: ${response.status} ${error}`)
  }

  return response.json()
}

export async function uploadImage(
  file: File | Blob,
  options?: {
    sessionId?: number
    triggerResponse?: boolean
    contextHint?: string
  }
): Promise<ImageUploadResponse> {
  const formData = new FormData()
  formData.append('file', file)

  if (options?.sessionId) {
    formData.append('session_id', String(options.sessionId))
  }
  if (options?.triggerResponse !== undefined) {
    formData.append('trigger_response', String(options.triggerResponse))
  }
  if (options?.contextHint) {
    formData.append('context_hint', options.contextHint)
  }

  // Use fetch instead of axios to avoid Content-Type issues with FormData
  // Dynamic import to avoid circular dependency issues
  const { useAuthStore } = await import('../stores/authStore')
  const token = useAuthStore.getState().accessToken

  const response = await fetch('/api/v1/media/image/upload', {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      // Don't set Content-Type - browser will set it with boundary for FormData
    },
    body: formData,
  })

  if (!response.ok) {
    const error = await response.text()
    throw new Error(`Upload failed: ${response.status} ${error}`)
  }

  return response.json()
}
